import { useTranslation } from "react-i18next";
import { BsChatTextFill, BsRobot } from "react-icons/bs";
import { FaRoute, FaStar } from "react-icons/fa";
import { GrTransaction, GrTroubleshoot } from "react-icons/gr";
import { IoSettings } from "react-icons/io5";
import { RiDashboardFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import {
  CancelReservationIcon,
  KidsManagementIcon,
  RidesCompletedIcon,
  ScheduleReservationIcon,
} from "../../assets/images/Icons";
import Sidebar from "../Sidebar";

const ParentSideMenu = ({ setCollapsedFromSidebar, isCollapsed }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.UserReducer);

  const menus = [
    {
      type: "link",
      text: t("ask_ai"),
      icon: <BsRobot />,
      to: "/ask-ai",
    },

    {
      type: "link",
      text: t("dashboard"),
      icon: <RiDashboardFill />,
      to: "/dashboard",
    },

    {
      type: "link",
      text: t("tracking"),
      icon: <FaRoute />,
      to: "/tracking",
    },

    {
      type: "link",
      text: `${t("manage")} ${t("kids")}`,
      icon: <KidsManagementIcon />,
      to: "/manage-kids",
    },

    {
      type: "link",
      text: t("reservations"),
      icon: <ScheduleReservationIcon />,
      to: "/reservations",
    },

    {
      type: "link",
      text: `${t("cancel")} ${t("reservation")}`,
      icon: <CancelReservationIcon />,
      to: "/cancel-reservation",
    },

    {
      type: "link",
      text: `${t("rides")} ${t("completed")}`,
      icon: <RidesCompletedIcon />,
      to: "/rides-completed",
    },

    ...(!user?.is_private
      ? [
          {
            type: "link",
            text: `${t("payment")} ${t("history")}`,
            icon: <GrTransaction />,
            to: "/my-payment-history",
          },
        ]
      : []),

    {
      type: "link",
      text: `${t("user")} ${t("communication")}`,
      icon: <BsChatTextFill />,
      to: "/user-communication",
    },

    {
      type: "link",
      text: `${t("ratings")} ${t("and")} ${t("reviews")}`,
      icon: <FaStar />,
      to: "/ratings-and-reviews",
    },
    {
      type: "link",
      icon: <GrTroubleshoot />,
      text: `${t("support")} ${t("and")} ${t("troubleshooting")}`,
      to: "/support",
    },
    {
      type: "link",
      text: t("settings"),
      icon: <IoSettings />,
      to: "/settings",
    },
  ];

  return (
    <Sidebar
      setCollapsedFromSidebar={setCollapsedFromSidebar}
      menu={menus}
      isCollapsed={isCollapsed}
      title="Parent"
    />
  );
};

export default ParentSideMenu;
